export default "__VITE_ASSET__rNBdDr55__"